let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("7dRAC")).then(() => parcelRequire('3eJYF'));